import { request } from './client';

// Paginated list of all returns with optional status filter + free-text search by returnId.
export const apiGetAllReturns = ({ page = 1, limit = 20, status = '', search = '' } = {}) => {
  const params = new URLSearchParams({ page, limit });
  if (status) params.set('status', status);
  if (search) params.set('search', search);
  return request(`/returns/admin/all?${params.toString()}`);
};

export const apiUpdateReturnStatus = (id, status, adminNote, refundAmount, shippingRefundAmount, otherRefundAmount) =>
  request(`/returns/admin/${id}/status`, {
    method: 'PUT',
    body: { status, adminNote, refundAmount, shippingRefundAmount, otherRefundAmount },
  });

export const apiAdminGetReturnReasons = () => request('/returns/admin/reasons');
export const apiAdminCreateReturnReason = (body) => request('/returns/admin/reasons', { method: 'POST', body });
export const apiAdminUpdateReturnReason = (id, body) => request(`/returns/admin/reasons/${id}`, { method: 'PUT', body });
export const apiAdminDeleteReturnReason = (id) => request(`/returns/admin/reasons/${id}`, { method: 'DELETE' });
